import React from 'react';
import {ChevronRight, Loader2} from 'lucide-react';
import {brand, brandFont} from '../../brand';

export type SourceButtonProps = {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  isLoading?: boolean;
  frame?: number;
};

export const SourceButton: React.FC<SourceButtonProps> = ({
  icon,
  title,
  subtitle,
  isLoading = false,
  frame = 0,
}) => {
  const spinDeg = (frame * 360) / 30;
  return (
    <div
      style={{
        width: '100%',
        padding: 18,
        borderRadius: 22,
        border: `1.5px solid ${brand.border}`,
        background: 'rgba(255,255,255,0.02)',
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        fontFamily: brandFont,
      }}
    >
      <div
        style={{
          width: 56,
          height: 56,
          borderRadius: 16,
          background: `${brand.primary}1F`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {isLoading ? (
          <span style={{display: 'inline-flex', transform: `rotate(${spinDeg}deg)`}}>
            <Loader2 size={28} color={brand.primary} strokeWidth={2.4} />
          </span>
        ) : (
          icon
        )}
      </div>
      <div style={{flex: 1, display: 'flex', flexDirection: 'column', gap: 3}}>
        <div
          style={{
            fontSize: 22,
            fontWeight: 600,
            color: brand.textPrimary,
            letterSpacing: -0.2,
          }}
        >
          {title}
        </div>
        <div
          style={{
            fontSize: 17,
            fontWeight: 500,
            color: brand.textSecondary,
            letterSpacing: 0.1,
            lineHeight: 1.2,
          }}
        >
          {subtitle}
        </div>
      </div>
      <ChevronRight size={26} color={brand.textMuted} strokeWidth={2.2} />
    </div>
  );
};
